export const DEFAULT_TZ = "Europe/Lisbon";
const pad = (n) => String(n).padStart(2, "0");

export const eur = (v) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "EUR" }).format(Number(v || 0));

export const todayISO = (tz = DEFAULT_TZ) =>
  new Intl.DateTimeFormat("en-CA", { timeZone: tz, year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());

export const nowMinutesIn = (tz = DEFAULT_TZ) => {
  const hm = new Intl.DateTimeFormat("en-GB", { timeZone: tz, hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).format(new Date());
  return toMin(hm);
};

export const toMin = (hm) => {
  const [h, m] = hm.split(":").map(Number);
  return h * 60 + m;
};

export const isoToDate = (iso) => {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d, 12);
};

export const dateToISO = (dt) => `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}`;

export const addDays = (iso, n) => {
  const d = isoToDate(iso);
  d.setDate(d.getDate() + n);
  return dateToISO(d);
};

export const shiftMonth = (month, n) => {
  const [y, m] = month.split("-").map(Number);
  const d = new Date(y, m - 1 + n, 1, 12);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}`;
};

export const mondayOf = (iso) => addDays(iso, -((isoToDate(iso).getDay() + 6) % 7));
export const lastDayOfMonth = (month) => {
  const [y, m] = month.split("-").map(Number);
  return `${month}-${pad(new Date(y, m, 0).getDate())}`;
};

export const fmtDate = (iso, opts = { weekday: "short", day: "2-digit", month: "short" }) =>
  iso ? isoToDate(iso).toLocaleDateString("pt-BR", opts) : "";
export const fmtLong = (iso) => fmtDate(iso, { weekday: "long", day: "numeric", month: "long" });
export const fmtShort = (iso) => fmtDate(iso, { day: "2-digit", month: "2-digit", year: "numeric" });
export const monthLabel = (month) => isoToDate(`${month}-01`).toLocaleDateString("pt-BR", { month: "long", year: "numeric" });
export const fmtDateTime = (isoString, tz = DEFAULT_TZ) =>
  isoString ? new Date(isoString).toLocaleString("pt-BR", { timeZone: tz, day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";

export const durationLabel = (min) => (min >= 60 ? `${Math.floor(min / 60)}h${min % 60 ? ` ${min % 60}min` : ""}` : `${min} min`);

export const STATUS = {
  confirmed: { label: "Confirmado", cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/25", dot: "bg-emerald-400" },
  completed: { label: "Concluído", cls: "bg-sky-500/10 text-sky-400 border-sky-500/25", dot: "bg-sky-400" },
  cancelled: { label: "Cancelado", cls: "bg-rose-500/10 text-rose-400 border-rose-500/25", dot: "bg-rose-400" },
  no_show: { label: "Cliente faltou", cls: "bg-amber-500/10 text-amber-400 border-amber-500/25", dot: "bg-amber-400" },
};

export const WEEKDAYS = ["Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado", "Domingo"];
export const WEEKDAYS_SHORT = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"];

export const KIND_LABELS = {
  day_off: "Folga",
  vacation: "Férias",
  holiday: "Feriado",
  time_block: "Bloqueio de horário",
  special_hours: "Horário excecional",
};

export const PERIODS = { manha: "Manhã", tarde: "Tarde", noite: "Noite", qualquer: "Qualquer período" };

export const initials = (name = "") =>
  name.split(" ").filter(Boolean).slice(0, 2).map((p) => p[0]).join("").toUpperCase();

export const firstName = (name = "") => name.split(" ")[0];

export const downloadBlob = (content, filename, type = "application/json") => {
  const url = URL.createObjectURL(new Blob([content], { type }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
